import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './feedback.loaders';
import { converters } from './feedback.converters';
import { FeedbackFilters } from './feedback.types';

export const feedbackKeys = queryKeyFactory('feedback');

export const useFeedbackItems = (filters: Partial<FeedbackFilters> = {}) => {
  return useQuery({
    queryKey: feedbackKeys.list(filters),
    queryFn: () => loaders.getFeedbackItems({ filters }),
    select: converters.getFeedbackItems,
    keepPreviousData: true,
  });
};

export const useFeedbackItem = (feedbackId: string) => {
  return useQuery({
    queryKey: feedbackKeys.detail(feedbackId),
    queryFn: () => loaders.getFeedbackItem({ feedbackId }),
    select: (data) => converters.getFeedbackItem(data),
    enabled: !!feedbackId,
  });
};

export const useDiscountFeedbackItems = (
  filters: Partial<FeedbackFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: feedbackKeys.list('discounts', filters),
    queryFn: () => loaders.getDiscountFeedbackItems({ filters }),
    select: converters.getFeedbackItems,
    keepPreviousData: true,
    ...options,
  });
};
